import { render } from "./ManagerRecurrences.html?vue&type=template&id=36db5739&external"
import script from "./ManagerRecurrences.vue?vue&type=script&lang=js"
export * from "./ManagerRecurrences.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__